'use client';

import { useEffect } from 'react';

export function useScrollToHash() {
    useEffect(() => {
        const hash = window.location.hash;
        if (hash) {
            const timeoutId = setTimeout(() => {
                // The fragment comes from the URL, so it is not guaranteed to be a valid CSS
                // selector — `#123` or `#a b` makes querySelector throw a SyntaxError, which
                // would otherwise surface as an uncaught error from this timer.
                let element: Element | null = null;
                try {
                    element = document.querySelector(hash);
                } catch {
                    return;
                }

                if (element) {
                    const elementPosition = element.getBoundingClientRect().top;
                    window.scrollTo({
                        top: elementPosition + window.scrollY,
                        behavior: 'smooth',
                    });
                }
            }, 100);

            return () => clearTimeout(timeoutId);
        }
    }, []);
}
